import React from "react";
import { useNavigate } from "react-router-dom";
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilLockLocked, cilUser } from "@coreui/icons";
import { useForm } from "react-hook-form";
import { successAlert } from "src/utils/Swal";
import { userLogin } from "src/api/authApi";

const Login = () => {
  let navigate = useNavigate();
  const { register, handleSubmit } = useForm();

  const onSubmit = async (payload) => {
    const response = await userLogin(payload);
    const LoginUserData = response.data;
    const { data, token, companyName } = LoginUserData;
    const sessionData = {
      role: response.data.data.role,
      token,
      schemaName: data.schemaName,
      companyN: companyName,
      id: data.id,
      branc: data.branchId,
      companyId: data.companyId,
      routes: response?.data?.permitted_routes,
    };
    Object.entries(sessionData).forEach(([key, value]) => {
      sessionStorage.setItem(key, value);
    });
    successAlert("Success", "Logged in Successfully");
    const currentDate = new Date();
    const remindDate = new Date();
    remindDate.setDate(currentDate.getDate() + 3);
    if (response.data.data.role === "company") {
      // navigate("/dashboard", { replace: true });
      window.location.href = "/dashboard";
    } else {
      // navigate("/customers", { replace: true });
      window.location.href = "/customers";
    }
  };

  return (
    <div
      className=" login-page min-vh-100 d-flex flex-row align-items-center login-page-background"
      style={{
        backgroundImage: `url('/img.jpg')`,
      }}
    >
      <CContainer fluid>
        <CRow
          className="justify-content-center"
          style={{ margin: 0, padding: 0 }}
        >
          <CCol
            md={6}
            className=" left-side d-none d-md-flex flex-column justify-content-between text-white p-4"
            style={{
              backgroundImage: `url('/img.jpg')`,
              backgroundPosition: "center",
              borderTopLeftRadius: "12px",
              borderBottomLeftRadius: "12px",
              width: "40%",
            }}
          >
            <div>
              <img src="/logo.png" style={{ width: "30%", background: "#fff", borderRadius: 10 }} />
            </div>
            <div className="text-center">
              <h2 style={{ fontWeight: "bold" }}>Hello, Welcome</h2>
            </div>
            <div></div>
          </CCol>
          <CCol
            md={6}
            className="right-side"
            style={{ width: "35%", margin: 0, padding: 0 }}
          >
            <CCardGroup>
              <CCard
                style={{
                  backgroundColor: "#f5f7fa",
                  borderTopRightRadius: "12px",
                  borderBottomRightRadius: "12px",
                }}
                className="p-4"
              >
                <CCardBody>
                  <CForm onSubmit={handleSubmit(onSubmit)}>
                    <div style={{ display: "grid", justifyContent: "center" }}>
                      <h1 className="loginSectionData">Login</h1>
                      <p className=" loginSectionData">Login to your account</p>
                    </div>
                    <h6>User Name:</h6>
                    <CInputGroup className="mb-3 ">
                      <CInputGroupText
                        style={{ backgroundColor: "#dfe3e8", border: "none" }}
                      >
                        <CIcon icon={cilUser} />
                      </CInputGroupText>
                      <CFormInput
                        placeholder="User Name"
                        autoComplete="userName"
                        name="userName"
                        {...register("userName", { required: true })}
                      />
                    </CInputGroup>
                    <h6>Password:</h6>
                    <CInputGroup className="mb-4">
                      <CInputGroupText style={{ backgroundColor: "#dfe3e8" }}>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type="password"
                        placeholder="Password"
                        autoComplete="current-password"
                        name="password"
                        {...register("password", { required: true })}
                      />
                    </CInputGroup>
                    <CRow>
                      <CCol className=" text-right">
                        <CButton type="submit" className="px-4 login-btn">
                          Login
                        </CButton>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol className=" text-right"></CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default Login;
